(() => {
  function showFace(card, showBack) {
    card.querySelector('[data-flip-front]')?.setAttribute('aria-hidden', String(showBack));
    card.querySelector('[data-flip-back]')?.setAttribute('aria-hidden', String(!showBack));
  }

  function syncBuilderCards(root = document) {
    root.querySelectorAll('.nuer-discovery-flip-card [data-scent]').forEach((input) => {
      showFace(input.closest('.nuer-discovery-flip-card'), input.checked);
    });
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('.nuer-discovery-flip-card [data-scent]')) {
      syncBuilderCards(event.target.closest('nuer-discovery'));
    }
  });

  document.addEventListener('click', (event) => {
    const card = event.target.closest('[data-discovery-flip]');
    if (!card) return;
    const showBack = card.getAttribute('aria-expanded') !== 'true';
    card.setAttribute('aria-expanded', String(showBack));
    card.classList.toggle('is-flipped', showBack);
    showFace(card, showBack);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncBuilderCards(), { once: true });
  } else {
    syncBuilderCards();
  }
  document.addEventListener('shopify:section:load', (event) => syncBuilderCards(event.target));
})();
